import { TRUNCATION_TOOLTIP_OVERLAY_STYLE } from '@/components/constants/tooltip';
import {
  TooltipCell as SharedTooltipCell,
  type TooltipCellProps as SharedTooltipCellProps,
} from '@/components/TooltipCell';
import React from 'react';

// `alwaysShow` is required (unlike the shared component it wraps): this
// component is reused by the Approval, Application, and Accounting drawers'
// Table/Card layouts (via `columns.tsx` in `TransactionsDetail`/`JournalInfo`,
// reused through the `InvoiceReportDetailDrawer` facade), and only Approval
// is in NA-5596 AC4 / NA-4766's clamp-only tooltip scope — Application and
// Accounting must keep the original always-show behavior. A default here
// would silently apply to all three drawers (this has broken twice:
// hardcoded `false` leaked into Application/Accounting's explanatory
// tooltip, then defaulting to `true` leaked into Approval's AC4 fields) — so
// every call site must derive and pass it explicitly from its own
// drawer-context signal instead.
export type TooltipCellProps = SharedTooltipCellProps & { alwaysShow: boolean };
export const TooltipCell: React.FC<TooltipCellProps> = (props) => {
  return (
    // The shared `TooltipCell`'s own `.tooltipContainer` class sets
    // `max-width: 168px` with no `!important`, so this inline `overlayStyle`
    // wins without needing one.
    <SharedTooltipCell
      {...props}
      overlayStyle={TRUNCATION_TOOLTIP_OVERLAY_STYLE}
    />
  );
};
